module.exports = __webpack_public_path__ + "static/media/03.846a8e95.png";